import request from './request';

export default {
    get_participants() {
        return request('/participants', {}, 'get');
    },
}
